// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wuOxX","type":"styles_type__2ASwX","choices":"styles_choices__E969R"};